import { render, staticRenderFns } from "./user-document-library.component.vue?vue&type=template&id=5d2a77db"
import script from "./user-document-library.component.ts?vue&type=script&lang=ts&external"
export * from "./user-document-library.component.ts?vue&type=script&lang=ts&external"
import style0 from "./user-document-library.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports